export default "__VITE_ASSET__BNL0N8U$__"